export const DATA_SCROLL_FIELD_ID_ATTR = 'data-form-kit-scroll-field-id';

/**
 * Пропсы для скролла к полю формы
 */
export type ScrollFieldProps = {
    /** data атрибут */
    [DATA_SCROLL_FIELD_ID_ATTR]: string;
};

/**
 * Возвращает id поля формы, позволяющие прокрутить страницу до поля формы
 */
export function getScrollFieldId({ formName, formId, fieldId }: { formName: string; formId: string; fieldId: string }) {
    return `${formName}-${formId}-${fieldId}`;
}

/**
 * Возвращает пропсы для поля формы, позволяющие прокрутить страницу до поля формы
 */
export function getScrollFieldProps({
    formName,
    formId,
    fieldId,
}: {
    formName: string;
    formId: string;
    fieldId: string;
}): ScrollFieldProps {
    return {
        [DATA_SCROLL_FIELD_ID_ATTR]: getScrollFieldId({ formName, formId, fieldId }),
    };
}

/**
 * Прокручивает страницу до поля формы
 */
export function scrollToField({ formId, fieldId, formName }: { formName: string; formId: string; fieldId: string }) {
    const scrollFieldId = getScrollFieldId({ formName, formId, fieldId });
    const element = document.querySelector(`[${DATA_SCROLL_FIELD_ID_ATTR}="${scrollFieldId}"]`);

    if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
}
